import React from 'react';
import { motion } from 'framer-motion';
import { ChevronLeft, ChevronRight, CalendarDays, Flame, Gem, Dumbbell } from 'lucide-react';

/** Barre d'en-tête du journal : navigation date + streak (jours consécutifs) + série
 * entraînement hebdo + gemmes. */
export const GamificationBar = ({ dateLabel, isToday, onPrev, onNext, gems, streak, workoutStreak, en }) => (
  <div className="flex items-center justify-between gap-2 mb-5 rounded-2xl bg-white/[0.035] backdrop-blur-xl border border-white/10 shadow-[0_0_30px_-12px_rgba(217,70,239,0.25)] px-3 py-2.5" data-testid="gamification-bar">
    <div className="flex items-center gap-1">
      <button onClick={onPrev} className="p-1.5 rounded-lg text-zinc-400 hover:text-white hover:bg-white/10 transition-colors" data-testid="header-date-prev">
        <ChevronLeft className="w-4 h-4" />
      </button>
      <div className="flex items-center gap-1.5 px-1.5" data-testid="header-calendar">
        <CalendarDays className="w-4 h-4 text-primary shrink-0" />
        <span className="text-sm font-bold text-white capitalize truncate max-w-[38vw] sm:max-w-none" data-testid="date-label">
          {isToday ? (en ? 'Today' : "Aujourd'hui") : dateLabel}
        </span>
      </div>
      <button onClick={onNext} disabled={isToday} className="p-1.5 rounded-lg text-zinc-400 hover:text-white hover:bg-white/10 transition-colors disabled:opacity-30" data-testid="header-date-next">
        <ChevronRight className="w-4 h-4" />
      </button>
    </div>
    <div className="flex items-center gap-1.5 shrink-0">
      {workoutStreak > 0 && (
        <motion.div
          key={`workout-streak-${workoutStreak}`} initial={{ scale: 1.3 }} animate={{ scale: 1 }}
          className="hidden sm:flex items-center gap-1 px-2.5 py-1.5 rounded-full bg-gradient-to-br from-sky-500/20 to-blue-600/10 border border-sky-500/20"
          data-testid="header-workout-streak-badge" title={en ? 'Consecutive weeks trained' : "Semaines d'entraînement consécutives"}
        >
          <Dumbbell className="w-3.5 h-3.5 text-sky-400" />
          <span className="text-xs font-extrabold text-sky-300 tabular-nums">{workoutStreak}</span>
        </motion.div>
      )}
      <motion.div
        key={`streak-${streak}`} initial={{ scale: 1.3 }} animate={{ scale: 1 }}
        className="flex items-center gap-1 px-2.5 py-1.5 rounded-full bg-gradient-to-br from-orange-500/20 to-red-500/10 border border-orange-500/20"
        data-testid="header-streak-badge" title={en ? 'Consecutive days logged' : 'Jours consécutifs enregistrés'}
      >
        <Flame className="w-3.5 h-3.5 text-orange-400" />
        <span className="text-xs font-extrabold text-orange-300 tabular-nums">{streak || 0}</span>
      </motion.div>
      <motion.div
        key={`gems-${gems}`} initial={{ scale: 1.3 }} animate={{ scale: 1 }}
        className="flex items-center gap-1 px-2.5 py-1.5 rounded-full bg-gradient-to-br from-sky-500/20 to-purple-500/10 border border-sky-500/20"
        data-testid="header-gems-badge" title={en ? 'Gems earned' : 'Gemmes gagnées'}
      >
        <Gem className="w-3.5 h-3.5 text-sky-400" />
        <span className="text-xs font-extrabold text-sky-300 tabular-nums">{gems || 0}</span>
      </motion.div>
    </div>
  </div>
);

export default GamificationBar;
